import { kea } from 'kea'

import heartLogic from '~/scenes/course/show/heart/logic'

export default kea({
  connect: {
    actions: [heartLogic, ['toggleWishlistStatus']],
    props: [heartLogic, ['isInWishlist', 'isToggling']]
  }
})
